import axios from '@shared/axios'

interface ResponseData {
  success: 'success'
  message: string
}

export const postOrderNumberLookup = async (orderNumber: string, lookupType: string): Promise<ResponseData> => {
  return new Promise<ResponseData>((resolve, reject) => {
    axios.post('/web_api/post_order_number_lookup', {
      order_number: orderNumber,
      lookup_type: lookupType,
    })
      .then(({ data }) => {
        if (data.error === 'error') {
          reject(Error(data.message))
        }
        else {
          resolve(data)
        }
      })
      .catch(({ response: { data } }) => {
        reject(Error(data.message))
      })
  })
}

export default postOrderNumberLookup
